import React from 'react'
import classNames from 'classnames'

export type AuthorProps = React.ComponentPropsWithoutRef<'figcaption'>

export const Author = ({ className, children, ...rest }: AuthorProps) => (
  <figcaption
    className={classNames('testimonial-card__author', className)}
    {...rest}
  >
    <div className="testimonial-card__meta">{children}</div>
  </figcaption>
)
